export const BaseApiUrls = {
  middlewareApiUrl: process.env.CSP_MIDDLEWARE_API
};

// TODO: Test Custom Headers work
export const AuthenticatedDataFetch = ({ apiUrl, accessToken, customHeaders }) => {
  try {
    return fetch(apiUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        ...(customHeaders || {})
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  } catch (error) {
    return error;
  }
};

export const AuthenticatedDataPost = ({ apiUrl, accessToken, payload, customHeaders }) => {
  try {
    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(customHeaders || {})
      },
      body: JSON.stringify(payload)
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  } catch (error) {
    return error;
  }
};

export const AuthenticatedFileUpload = ({ apiUrl, accessToken, file, customHeaders }) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    return fetch(apiUrl, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': undefined,
        ApplicationName: 'CSP',
        ApplicationEnvironment: 'DEV',
        DomainName: 'Pet',
        ...(customHeaders || {})
      },
      body: formData
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  } catch (error) {
    return error;
  }
};

export const UnAuthenticatedDataPost = ({ apiUrl, payload, customHeaders }) => {
  try {
    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(customHeaders || {})
      },
      body: JSON.stringify(payload)
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  } catch (error) {
    return error;
  }
};

export const AuthenticatedDataDelete = ({ apiUrl, accessToken, customHeaders }) => {
  try {
    return fetch(apiUrl, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        ...(customHeaders || {})
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  } catch (error) {
    return error;
  }
};
